import mutations from './mutations'
import actions from './action'
import getters from './getters'


const state = {
	openid:null,
	channel:null,
	userToken:null,	
	userInfo:null,
	guestInfo:null,
	dateList:{},
	sysConfig: {}, 	//系统配置信息
	wechatUserInfo:null,
	navMenus:null,

	provinces: null, 	//省份列表
	citys:null, 			//城市列表
	districts: null,
	town: null, 		//镇区列表
	pageCache:{},
	trace:{},
	maintain:{},
	pageConfig:{},
	pageConfigDetail:{},
	serviceUrl:null,
	saveWarehouse:false,
	orphanShowTime:0,
	deviceId:'',
	setLanguage: ''
}

export default {
	state,
 	getters,
  	actions,
  	mutations,
}